module.exports = __webpack_public_path__ + "img/p13.02c5cb7e.png";